import {
  NEUTRAL,
  SUCCESS,
  ERROR,
  WARNING,
  TERTIARY,
  BACKGROUND,
  TEXT,
  PRIMARY_LEARN,
  SECONDARY_LEARN,
  OVERLAY,
  TEST,
  BUTTON_SUCCESS,
} from "../../primitives/colors";
import type { ThemeColors } from "../../semantic/colors";
import { buildSubjectColors } from "./subjectColors";

export const learnColors: ThemeColors = {
  primary: PRIMARY_LEARN,
  secondary: SECONDARY_LEARN,
  tertiary: TERTIARY,
  neutral: NEUTRAL,
  success: SUCCESS,
  error: ERROR,
  warning: WARNING,
  text: TEXT,
  background: BACKGROUND,
  subject: buildSubjectColors({
    primary: PRIMARY_LEARN,
    warning: WARNING,
    success: SUCCESS,
    error: ERROR,
    tertiary: TERTIARY,
  }),
  overlay: OVERLAY,
  test: TEST,
  buttonSuccess: BUTTON_SUCCESS,
};
